(() => {
  const page = document.querySelector('[data-pnm-page]');

  if (!page) return;


  const clean = value =>
    String(value ?? '').trim();


  const key = value =>
    clean(value).toLowerCase();


  const esc = value =>
    String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');


  let mentors = [];


  /* PNM UNIVERSAL SEARCH */

  const search =
    page.querySelector(
      '[data-pnm-search]'
    );

  const searchClear =
    page.querySelector(
      '[data-pnm-search-clear]'
    );


  /* PNM FILTER DRAWER REFS */

  const filterToggle =
    page.querySelector(
      '[data-pnm-filter-toggle]'
    );

  const filterDrawer =
    page.querySelector(
      '[data-pnm-filter-drawer]'
    );

  const filterCount =
    page.querySelector(
      '[data-pnm-filter-count]'
    );



  const college =
    page.querySelector('[data-pnm-college]');

  const location =
    page.querySelector('[data-pnm-location]');

  const department =
    page.querySelector('[data-pnm-department-select]');

  const count =
    page.querySelector('[data-pnm-count]');

  const grid =
    page.querySelector('[data-pnm-grid]');

  const empty =
    page.querySelector('[data-pnm-empty]');

  const clear =
    page.querySelector('[data-pnm-clear]');

  const emptyReset =
    page.querySelector('[data-pnm-reset-empty]');

  const departmentButtons =
    [...page.querySelectorAll('[data-pnm-department]')];

  let quickDepartment = '';


  function unique(values) {
    return [...new Set(
      values.filter(Boolean)
    )].sort();
  }


  /* Normalize city labels for the LOCATION FILTER ONLY.
     Keep original mentor.location untouched for cards and search.
     Examples: Bangalore / Bengaluru, Karnataka / Bengaluru ,Karnataka
     all use one filter choice: Bengaluru. */
  function canonicalLocation(value) {
    let name = clean(value)
      .normalize('NFKC')
      .replace(/\s+/g, ' ')
      .replace(/[,，]\s*/g, ',')
      .trim();

    if (!name) return '';

    // The public location field mixes city and state; filter by city.
    name = name.split(',')[0].trim();

    // Also handle "Bengaluru Karnataka" / "Bengaluru - Karnataka".
    name = name.replace(
      /(?:\s+|\s*[-–|]\s*)(?:andhra pradesh|arunachal pradesh|himachal pradesh|madhya pradesh|uttar pradesh|tamil nadu|west bengal|karnataka|telangana|maharashtra|odisha|orissa|punjab|rajasthan|gujarat|kerala|haryana|bihar|goa|assam|delhi|chandigarh|jharkhand|uttarakhand|chhattisgarh|tamilnadu)\s*$/i,
      ''
    ).trim();

    if (!name) return '';

    const normalized = name.toLocaleLowerCase('en-IN')
      .replace(/[._-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    const aliases = {
      'bangalore': 'Bengaluru',
      'bangaluru': 'Bengaluru',
      'banglore': 'Bengaluru',
      'bengalore': 'Bengaluru',
      'bengaluru': 'Bengaluru',
      'bangalore urban': 'Bengaluru',
      'bengaluru urban': 'Bengaluru',
      'bombay': 'Mumbai',
      'mumbai': 'Mumbai',
      'madras': 'Chennai',
      'chennai': 'Chennai',
      'calcutta': 'Kolkata',
      'kolkata': 'Kolkata',
      'gurgaon': 'Gurugram',
      'gurugram': 'Gurugram',
      'bhubaneshwar': 'Bhubaneswar',
      'bhubaneswar': 'Bhubaneswar'
    };

    return aliases[normalized] ||
      normalized.replace(/(^|\s)[a-z]/g, letter => letter.toUpperCase());
  }


  // Collapse only display-level duplicates; never combine mentor records.
  function distinctFilterOptions(property) {
    const seen = new Map();

    mentors.forEach(mentor => {
      const raw = clean(mentor[property]).replace(/\s+/g, ' ');
      const value = property === 'location'
        ? canonicalLocation(raw)
        : raw;
      const dedupeKey = key(value)
        .normalize('NFKC')
        .replace(/\s+/g, ' ')
        .replace(/\s*,\s*/g, ',')
        .trim();

      if (dedupeKey && !seen.has(dedupeKey)) {
        seen.set(dedupeKey, value);
      }
    });

    return [...seen.values()].sort((a, b) => a.localeCompare(b));
  }


  function populate(select, values, label) {
    select.innerHTML =
      `<option value="">${label}</option>`;

    values.forEach(value => {

      const option =
        document.createElement('option');

      option.value = value;
      option.textContent = value;

      select.appendChild(option);

    });
  }


  populate(
    college,
    unique(mentors.map(item => item.college)),
    'All colleges'
  );


  populate(
    location,
    unique(mentors.map(item => item.location)),
    'All locations'
  );


  populate(
    department,
    unique(mentors.map(item => item.department)),
    'All departments'
  );


  function initials(name) {
    return clean(name)
      .split(/\s+/)
      .slice(0,2)
      .map(part => part[0] || '')
      .join('')
      .toUpperCase();
  }


  function card(mentor) {

    const rating =
      Number(mentor.rating || 0);

    const tags =
      mentor.expertise
        .slice(0,4)
        .map(tag =>
          `<span class="pnm-card__tag">${esc(tag)}</span>`
        )
        .join('');


    const meta =
      [
        mentor.program,
        mentor.year,
        mentor.location
      ]
      .filter(Boolean)
      .join(' · ');


    const photo =
      mentor.photo
        ? `
          <img
            src="${esc(mentor.photo)}"
            alt="${esc(mentor.name)}"
            loading="lazy"
          >
        `
        : `
          <div class="pnm-card__placeholder">
            ${esc(initials(mentor.name))}
          </div>
        `;


    return `
      <article class="pnm-card">

        <div class="pnm-card__image">

          ${photo}

          <span class="pnm-card__verified">
            ✓ Verified Mentor
          </span>

        </div>


        <div class="pnm-card__body">

          <div class="pnm-card__head">

            <h4>
              ${esc(mentor.name)}
            </h4>

            <span class="pnm-card__rating">
              <b>★</b>
              ${rating ? rating.toFixed(1) : 'New'}
              ${mentor.reviews ? ` · ${mentor.reviews}` : ''}
            </span>

          </div>


          <div class="pnm-card__college-highlight">
            <span>COLLEGE</span>
            <strong>
              ${esc(mentor.college || 'College not added')}
            </strong>
          </div>


          <div class="pnm-card__meta">
            ${esc(meta)}
          </div>


          <div class="pnm-card__tags">
            ${tags}
          </div>


          <p class="pnm-card__bio">
            ${esc(mentor.bio)}
          </p>


          <div class="pnm-card__price">
            Session options
            <strong>
              Quick 15 · Deep Dive 30
            </strong>
          </div>


          <div class="pnm-card__actions">

            <a
              href="${esc(mentor.profile_url || '#')}"
              class="pnm-card__action pnm-card__action--ghost"
            >
              View Profile
            </a>

            <a
              href="${esc(mentor.booking_url || mentor.profile_url || '#')}"
              class="pnm-card__action pnm-card__action--primary"
            >
              Book Session →
            </a>

          </div>

        </div>

      </article>
    `;
  }



  function searchMatch(mentor) {

    const query =
      key(
        search?.value || ''
      );


    if (!query) {
      return true;
    }


    /*
      Search all useful public mentor information.

      Examples:
      "RV CSE"
      "Christ commerce"
      "Bengaluru placements"
      "design internship"

      Every typed word must appear somewhere
      in the mentor's searchable information.
    */
    const searchable =
      key(
        [
          mentor.name,
          mentor.college,
          mentor.location,
          mentor.department,
          mentor.program,
          mentor.year,
          mentor.expertise,
          mentor.bio
        ]
          .filter(Boolean)
          .join(' ')
      );


    const terms =
      query
        .split(/\s+/)
        .filter(Boolean);


    return terms.every(
      term =>
        searchable.includes(term)
    );

  }


  function quickMatch(mentor) {

    if (!quickDepartment) {
      return true;
    }

    const value =
      key(
        `${mentor.department} ${mentor.program}`
      );

    if (quickDepartment === 'medical') {

      return (
        value.includes('medical') ||
        value.includes('medicine') ||
        value.includes('allied') ||
        value.includes('nursing') ||
        value.includes('pharmacy')
      );

    }

    return value.includes(quickDepartment);
  }



  function syncMentorFilterUi() {

    const activeCount =
      [
        college?.value,
        location?.value,
        department?.value
      ]
        .filter(
          value =>
            clean(value)
        )
        .length;


    if (filterCount) {
      filterCount.textContent =
        String(activeCount);
    }

  }


  /* PN_MENTORS_INDEPENDENT_SWIPE_ROWS_V4 — presentation only.
     Every six currently filtered mentors get their own mobile scroll viewport.
     Desktop stays the original flat grid. No filtering/eligibility changes. */
  const mentorMobileMedia = window.matchMedia('(max-width: 749px)');

  function mentorRowsMarkup(results) {
    if (!mentorMobileMedia.matches) return results.map(card).join('');
    const rows = [];
    for (let i = 0; i < results.length; i += 6) {
      const end = Math.min(i + 6, results.length);
      rows.push(
        `<div class="pnm-mobile-row" role="group" tabindex="0" ` +
        `aria-label="Mentors ${i + 1} to ${end}">` +
        results.slice(i, end).map(card).join('') +
        '</div>'
      );
    }
    return rows.join('');
  }

  // Rebuild only if crossing the mobile/desktop layout breakpoint.
  mentorMobileMedia.addEventListener('change', () => render());

  function render() {

    const c = key(college.value);
    const l = key(location.value);
    const d = key(department.value);


    const results =
      mentors.filter(mentor => (

        (!c || key(mentor.college) === c)

        &&

        (!l || key(canonicalLocation(mentor.location)) === l)

        &&

        (!d || key(mentor.department) === d)

        &&

        searchMatch(mentor)

        &&

        quickMatch(mentor)

      ));


    grid.innerHTML = mentorRowsMarkup(results);


    count.textContent =
      results.length;


    const hasResults =
      results.length > 0;


    grid.hidden =
      !hasResults;


    empty.hidden =
      hasResults;

    syncMentorFilterUi();
  }


  function reset() {

    college.value = '';
    location.value = '';
    department.value = '';

    if (search) {
      search.value = '';
    }

    if (searchClear) {
      searchClear.hidden = true;
    }

    quickDepartment = '';


    departmentButtons.forEach(button => {

      button.classList.toggle(
        'is-active',
        !button.dataset.pnmDepartment
      );

    });


    render();
  }



  search?.addEventListener(
    'input',
    () => {

      if (searchClear) {
        searchClear.hidden =
          !search.value.trim();
      }

      render();

    }
  );


  search?.addEventListener(
    'keydown',
    event => {

      if (
        event.key === 'Escape' &&
        search.value
      ) {

        search.value = '';

        if (searchClear) {
          searchClear.hidden = true;
        }

        render();

      }

    }
  );


  searchClear?.addEventListener(
    'click',
    () => {

      if (!search) {
        return;
      }

      search.value = '';
      searchClear.hidden = true;

      search.focus();

      render();

    }
  );



  filterToggle?.addEventListener(
    'click',
    () => {

      if (!filterDrawer) {
        return;
      }


      const open =
        filterDrawer.classList.toggle(
          'is-open'
        );


      filterToggle.setAttribute(
        'aria-expanded',
        open
          ? 'true'
          : 'false'
      );

    }
  );


  college.addEventListener('change', render);
  location.addEventListener('change', render);
  department.addEventListener('change', render);

  clear.addEventListener('click', reset);

  emptyReset?.addEventListener('click', reset);


  departmentButtons.forEach(button => {

    button.addEventListener('click', () => {

      quickDepartment =
        key(button.dataset.pnmDepartment);


      departmentButtons.forEach(item =>
        item.classList.remove('is-active')
      );


      button.classList.add('is-active');

      render();

    });

  });



  async function loadPublishedMentors() {

    try {

      const rows =
        await window.PeerNestDB
          .getAllPublishedMentors();


      mentors =
        (Array.isArray(rows)
          ? rows
          : []
        ).map(item => {

          const program =
            clean(
              item.program_name
            );


          return {

            id:
              item.id,

            name:
              clean(
                item.display_name
              ),

            college:
              clean(
                item.college_name
              ),

            location:
              clean(
                item.location_name
              ),

            department:
              program,

            program,

            year:
              item.graduation_year
                ? `Class of ${item.graduation_year}`
                : '',

            rating:
              Number(
                item.rating || 0
              ),

            reviews:
              Number(
                item.review_count || 0
              ),

            expertise:
              Array.isArray(
                item.expertise
              )
                ? item.expertise
                    .map(clean)
                    .filter(Boolean)
                : [],

            bio:
              clean(
                item.bio
              ),

            photo:
              clean(
                item.photo_url
              ),

            slug:
              clean(
                item.slug
              ),

            profile_url:
              item.slug
                ? `/pages/mentor-profile?slug=${encodeURIComponent(
                    item.slug
                  )}`
                : '#',

            booking_url:
              item.slug
                ? `/pages/mentor-profile?slug=${encodeURIComponent(
                    item.slug
                  )}#sessions`
                : '#'

          };

        });


      // Populate all three filters ONLY AFTER the approved public mentor
      // records have loaded. The original boot-time mentors array is empty.
      const filterSources = [
        [college, 'college', 'All colleges'],
        [location, 'location', 'All locations'],
        [department, 'department', 'All departments']
      ];

      filterSources.forEach(([select, property, label]) => {
        const selected = property === 'location'
          ? canonicalLocation(select.value)
          : clean(select.value);
        const values = distinctFilterOptions(property);

        populate(select, values, label);

        // Retain selection by canonical option, not inconsistent raw formatting.
        const restored = [...select.options].find(option =>
          key(option.value) === key(selected)
        );
        if (restored) select.value = restored.value;

        // Do not invent location or department metadata if the RPC omits it.
        if (!values.length && mentors.length) {
          console.warn(`[PeerNest] No ${property} values in public mentor records.`);
        }
      });

      console.log(
        '[PeerNest] Live mentors loaded:',
        mentors.length
      );

    }

    catch (error) {

      console.error(
        '[PeerNest] Live mentor loading failed:',
        error
      );

      mentors = [];

    }


    await applyCollegeDeepLink();

  }



  /* PN_PHASE2_COLLEGE_DEEPLINK */

  async function applyCollegeDeepLink() {

    const collegeId =
      new URLSearchParams(
        window.location.search
      ).get('college');


    if (!collegeId) {
      render();
      return;
    }


    try {

      const colleges =
        await window.PeerNestDB
          .getPublishedColleges();


      const selectedCollege =
        colleges.find(
          item =>
            item.id === collegeId
        );


      if (!selectedCollege) {
        render();
        return;
      }


      let option =
        [...college.options]
          .find(item => {

            const optionValue =
              key(item.value);

            const optionText =
              key(item.textContent);

            return (
              optionValue ===
                key(selectedCollege.name)

              ||

              optionText ===
                key(selectedCollege.name)

              ||

              optionValue ===
                key(
                  selectedCollege.short_name ||
                  ''
                )

              ||

              optionText ===
                key(
                  selectedCollege.short_name ||
                  ''
                )
            );

          });


      /*
        If there are currently zero seed/approved mentors
        from this college, the old dropdown may not contain it.
        Add the selected college so the filter still reflects
        the route correctly.
      */

      if (!option) {

        option =
          document.createElement(
            'option'
          );

        option.value =
          selectedCollege.name;

        option.textContent =
          selectedCollege.name;

        college.appendChild(
          option
        );

      }


      college.value =
        option.value;


      render();


      document
        .getElementById(
          'pnm2-discover'
        )
        ?.scrollIntoView({
          behavior:'smooth',
          block:'start'
        });


      console.log(
        '[PeerNest] Mentor page filtered to:',
        selectedCollege.name
      );

    }

    catch (error) {

      console.error(
        '[PeerNest] College mentor filter failed:',
        error
      );

      render();

    }

  }


  if (window.PeerNestDB) {

    loadPublishedMentors();

  }

  else {

    document.addEventListener(
      'peernest:supabase-ready',
      loadPublishedMentors,
      {
        once:true
      }
    );

  }


})();

/* PN FULL MENTOR CARD CLICK START */

(() => {

  if (window.__pnFullMentorCardClick) {
    return;
  }

  window.__pnFullMentorCardClick = true;


  function pnCardClickIsInteractive(target) {

    return !!target.closest(
      'a, button, input, select, textarea, label, summary, details, [role="button"], [role="link"]'
    );

  }


  document.addEventListener(
    'click',
    event => {

      const target = event.target;

      if (!(target instanceof Element)) {
        return;
      }


      const card =
        target.closest('.pnm-card');

      if (!card) {
        return;
      }


      /*
        Existing buttons/links retain their own behaviour:
        View Profile
        Book Session
        etc.
      */
      if (pnCardClickIsInteractive(target)) {
        return;
      }


      const profileLink =
        card.querySelector(
          'a.pnm-card__action--ghost[href]'
        );


      if (
        !profileLink ||
        !profileLink.getAttribute('href') ||
        profileLink.getAttribute('href') === '#'
      ) {
        return;
      }


      profileLink.click();

    }
  );


})();

/* PN FULL MENTOR CARD CLICK END */

